import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"16px"}},[_c('span',{staticStyle:{"text-decoration":"underline","cursor":"pointer"},on:{"click":_vm.openFile}},[_vm._v(" "+_vm._s(_vm.file.Name)+" ("+_vm._s(_vm.size)+") ")]),_c(VIcon,{staticClass:"ml-2",on:{"click":_vm.openFile}},[_vm._v("mdi-download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }